import { countryCodeToCurrency } from '../../constants/currencyCodes';
import { EVENTS, EVENT_VALUE_NOFLAKE_TO_TITAN } from '../../constants/noflake/noflakeSchema';
import { TITAN_EVENTS } from '../../constants/titan';
import { titan } from '../../lib/productAnalytics';

export const RECEIVE_ANALYTICS_DATA = 'RECEIVE_ANALYTICS_DATA';

export const receiveAndLogData =
  ({ data, type, value }) =>
  async (dispatch, getState) => {
    dispatch({
      type: RECEIVE_ANALYTICS_DATA,
      data,
    });

    try {
      fetch(process.env.MONITORING_ANALYTICS_URL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          event_type: type,
          event_value: value,
        }),
      });

      if (type === EVENTS.PAGE_LOAD) {
        const {
          page: { countryCode },
          orderInfo: { currentOrderNumber, orderCurrencyCode },
          returnItems: { returnItems },
          returnMethods: { selectedMethod, selectedMethodKey },
          returnOptions: {
            selectedOptionMethodKey,
            returnOptionMethods: { [selectedOptionMethodKey]: selectedOptionMethod } = {},
          },
        } = getState();
        const {
          return_cost: {
            return_shipping_fee: shipping,
            return_tax_credit: tax,
            estimated_refund: total,
          } = {},
        } = selectedOptionMethod || selectedMethod;

        const event =
          value === 'confirmation'
            ? TITAN_EVENTS.ORDER_COMPLETED
            : TITAN_EVENTS.CHECKOUT_STEP_VIEWED;

        titan.event(event, {
          order_id: currentOrderNumber,
          products: returnItems.map(
            ({
              item_id: itemId,
              product_sku: sku,
              item_name: name,
              item_price: price,
              return_qty: quantity,
              product_image_url: imageUrl,
            }) => ({
              product_id: `${itemId}`,
              sku,
              name,
              price,
              quantity,
              image_url: imageUrl,
            }),
          ),
          shipping,
          tax,
          total,
          currency: orderCurrencyCode || countryCodeToCurrency[countryCode],
          shipping_method: selectedOptionMethodKey || selectedMethodKey,
          ...(EVENT_VALUE_NOFLAKE_TO_TITAN[EVENTS.PAGE_LOAD]
            ? EVENT_VALUE_NOFLAKE_TO_TITAN[EVENTS.PAGE_LOAD][value]
            : undefined),
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

export const logData =
  ({ data, type, value }) =>
  async (_, getState) => {
    const { analytics: { data: analyticsData } = {} } = getState();

    try {
      fetch(process.env.MONITORING_ANALYTICS_URL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...analyticsData,
          ...data,
          event_type: type,
          event_value: value,
        }),
      });
    } catch (e) {
      console.log(e);
    }
  };
